import {
  GET_TRIBUN_NOTIFICATION_COUNT_REQUEST,
  GET_TRIBUN_NOTIFICATION_COUNT_SUCCESS,
  GET_TRIBUN_NOTIFICATION_COUNT_FAILURE,
  GET_PROFIL_TRIBUN_COUPONS_REQUEST,
  GET_PROFIL_TRIBUN_COUPONS_SUCCESS,
  GET_PROFIL_TRIBUN_COUPONS_FAILURE,
  GET_PROFIL_TRIBUN_COUPONS_INITIAL_STATE,
  LIKE_OR_UNLIKE_COUPON_REQUEST,
  LIKE_OR_UNLIKE_COUPON_SUCCESS,
  LIKE_OR_UNLIKE_COUPON_FAILURE,
  GET_TRIBUN_FOLLOWINGS_REQUEST,
  GET_TRIBUN_FOLLOWINGS_SUCCESS,
  GET_TRIBUN_FOLLOWINGS_FAILURE,
  GET_TRIBUN_FOLLOWERS_REQUEST,
  GET_TRIBUN_FOLLOWERS_SUCCESS,
  GET_TRIBUN_FOLLOWERS_FAILURE,
  FOLLOW_TRIBUN_USER_REQUEST,
  FOLLOW_TRIBUN_USER_SUCCESS,
  FOLLOW_TRIBUN_USER_FAILURE,
  SHOW_OR_HIDE_CHECKBOX_TRIBUN_COUPONS_REQUEST,
  SHOW_OR_HIDE_CHECKBOX_TRIBUN_COUPONS_SUCCESS,
  SHOW_OR_HIDE_CHECKBOX_TRIBUN_COUPONS_FAILURE,
  SHOW_OR_HIDE_COUOPON_REQUEST,
  SHOW_OR_HIDE_COUOPON_SUCCESS,
  SHOW_OR_HIDE_COUOPON_FAILURE,
  SEND_COMMENT_REQUEST,
  SEND_COMMENT_SUCCESS,
  SEND_COMMENT_FAILURE,
  DELETE_COMMENT_REQUEST,
  DELETE_COMMENT_SUCCESS,
  DELETE_COMMENT_FAILURE,
  COMMENT_FORBID_ALLOW_REQUEST,
  COMMENT_FORBID_ALLOW_SUCCESS,
  COMMENT_FORBID_ALLOW_FAILURE,
  SET_PIN_FEED_REQUEST,
  SET_PIN_FEED_SUCCESS,
  SET_PIN_FEED_FAILURE,
  REMOVE_PIN_FEED_REQUEST,
  REMOVE_PIN_FEED_SUCCESS,
  REMOVE_PIN_FEED_FAILURE,
  GET_PINNED_FEED_REQUEST,
  GET_PINNED_FEED_SUCCESS,
  GET_PINNED_FEED_FAILURE,
  GET_TRIBUN_PUSH_FOLLOWING_USERS_REQUEST,
  GET_TRIBUN_PUSH_FOLLOWING_USERS_SUCCESS,
  GET_TRIBUN_PUSH_FOLLOWING_USERS_FAILURE,
  GET_TRIBUN_BLOCKED_USERS_REQUEST,
  GET_TRIBUN_BLOCKED_USERS_SUCCESS,
  GET_TRIBUN_BLOCKED_USERS_FAILURE,
  GET_USER_PUSH_COUNT_SUCCESS,
  GET_USER_PUSH_COUNT_REQUEST,
  GET_USER_PUSH_COUNT_FAILURE,
  GET_BLOCK_USER_COUNT_REQUEST,
  GET_BLOCK_USER_COUNT_SUCCESS,
  GET_BLOCK_USER_COUNT_FAILURE,
  GET_MUTED_USER_COUNT_REQUEST,
  GET_MUTED_USER_COUNT_SUCCESS,
  GET_MUTED_USER_COUNT_FAILURE,
  GET_TRIBUN_MUTED_USERS_REQUEST,
  GET_TRIBUN_MUTED_USERS_SUCCESS,
  GET_TRIBUN_MUTED_USERS_FAILURE,
  GET_TRIBUN_MUTED_USERS_RESET,
  GET_TRIBUN_PUSH_FOLLOWING_USERS_RESET,
  GET_TRIBUN_BLOCKED_USERS_RESET,
  UPDATE_TRIBUN_COUPON_NAME_REQUEST,
  UPDATE_TRIBUN_COUPON_NAME_SUCCESS,
  UPDATE_TRIBUN_COUPON_NAME_FAILURE,
  DELETE_TRIBUN_COUPON_NAME_REQUEST,
  DELETE_TRIBUN_COUPON_NAME_SUCCESS,
  DELETE_TRIBUN_COUPON_NAME_FAILURE,
} from 'Store/constants';

import EnvironmentManager from 'Utils/environmentManager';

const initialState = {
  past: [],
  today: [],
  follow: [],
  pinned: [],
  count: {},
  lastPage: false,
  todayLastPage: false,
  isLoading: null,
  error: null,
  isFollowDataFetch: null,
  notificationUser: [],
  blockUser: [],
  mutedUsers: [],
  pushCount: null,
  blockCount: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_TRIBUN_NOTIFICATION_COUNT_REQUEST:
      return { ...state, isLoading: true, error: null };
    case GET_USER_PUSH_COUNT_REQUEST:
      return { ...state, isLoading: true, error: null };
    case GET_BLOCK_USER_COUNT_REQUEST:
      return { ...state, isLoading: true, error: null };
    case GET_MUTED_USER_COUNT_REQUEST:
      return { ...state, isLoading: true, error: null };

    case GET_TRIBUN_NOTIFICATION_COUNT_SUCCESS:
      return {
        ...state,
        count: { ...action.payload },
        isLoading: false,
        error: null,
      };
    case GET_BLOCK_USER_COUNT_SUCCESS:
      return {
        ...state,
        blockCount: { ...action.payload },
        isLoading: false,
        error: null,
      };
    case GET_MUTED_USER_COUNT_SUCCESS:
      return {
        ...state,
        mutedUserCount: { ...action.payload },
        isLoading: false,
        error: null,
      };
    case GET_USER_PUSH_COUNT_SUCCESS:
      return {
        ...state,
        pushCount: { ...action.payload },
        isLoading: false,
        error: null,
      };
    case GET_TRIBUN_NOTIFICATION_COUNT_FAILURE:
      return { ...state, isLoading: false, error: action.payload };

    case GET_BLOCK_USER_COUNT_FAILURE:
      return { ...state, isLoading: false, error: action.payload };
    case GET_USER_PUSH_COUNT_FAILURE:
      return { ...state, isLoading: false, error: action.payload };
    case GET_MUTED_USER_COUNT_FAILURE:
      return { ...state, isLoading: false, error: action.payload };

    case GET_PROFIL_TRIBUN_COUPONS_REQUEST:
      return { ...state, isLoading: true, error: null };
    case GET_PROFIL_TRIBUN_COUPONS_SUCCESS: {
      
      const mergeUniqueByCoupon = list =>
        Array.from(new Set(list.map(a => a.coupon?.couponId))).map(couponId =>
          list.find(a => a.coupon?.couponId === couponId)
        );

      const uniquePast = mergeUniqueByCoupon([...state.past, ...(action.past || [])]);
      const uniqueToday = mergeUniqueByCoupon([...state.today, ...(action.today || [])]);

      return {
        ...state,
        past: uniquePast,
        today: uniqueToday,
        lastPage: action.lastPage !== undefined ? action.lastPage : state.lastPage,
        todayLastPage:
          action.todayLastPage !== undefined ? action.todayLastPage : state.todayLastPage,
        isLoading: false,
        error: null,
      };
    }
    case GET_PROFIL_TRIBUN_COUPONS_FAILURE: {
      const errorMessage = action.isCurrentUser
        ? EnvironmentManager.getMessageText({ key: 'tribun_kupon' })
        : EnvironmentManager.getMessageText({ key: 'tribun_kupon_diger' });

      const error = !state.past.length ? errorMessage : action.payload;

      return {
        ...state,
        lastPage: action.lastPage,
        todayLastPage:
          action.todayLastPage !== undefined ? action.todayLastPage : state.todayLastPage,
        isLoading: false,
        error: error,
      };
    }

    case GET_PROFIL_TRIBUN_COUPONS_INITIAL_STATE:
      return { ...initialState, count: state.count };

    case LIKE_OR_UNLIKE_COUPON_REQUEST:
      return { ...state, isLoading: true, error: null };
    case LIKE_OR_UNLIKE_COUPON_SUCCESS: {
      let newState = {
        ...state,
      };
      if (action.tabType === 'profile') {
        newState = {
          past: state.past.map(feed => {
            if (feed.feedId === action.feedId) {
              feed.likes = feed.liked ? feed.likes - 1 : feed.likes + 1;
              feed.liked = !feed.liked;

              return feed;
            } else {
              return feed;
            }
          }),
          pinned: state.pinned.map(feed => {
            if (feed.feedId === action.feedId) {
              feed.likes = feed.liked ? feed.likes - 1 : feed.likes + 1;
              feed.liked = !feed.liked;
              return feed;
            } else {
              return feed;
            }
          }),
          today: state.today.map(feed => {
            if (feed.feedId === action.feedId) {
              feed.likes = feed.liked ? feed.likes - 1 : feed.likes + 1;
              feed.liked = !feed.liked;
              return feed;
            } else {
              return feed;
            }
          }),
        };
      }

      return {
        ...newState,
      };
    }
    case LIKE_OR_UNLIKE_COUPON_FAILURE:
      return { ...state, isLoading: false, error: action.payload };

    case GET_TRIBUN_FOLLOWINGS_REQUEST:
      return {
        ...state,
        isLoading: true,
        isFollowDataFetch: false,
        error: null,
      };
    case GET_TRIBUN_FOLLOWINGS_SUCCESS:
      return {
        ...state,
        follow: action.payload.users.length
          ? [...state.follow, ...action.payload.users]
          : [],
        lastPage: action.lastPage,
        isLoading: false,
        isFollowDataFetch: true,
        error: null,
      };
    case GET_TRIBUN_FOLLOWINGS_FAILURE:
      return {
        ...state,
        lastPage: action.lastPage,
        isLoading: false,
        isFollowDataFetch: true,
        error: action.payload,
      };

    case GET_TRIBUN_FOLLOWERS_REQUEST:
      return {
        ...state,
        isLoading: true,
        isFollowDataFetch: false,
        error: null,
      };
    case GET_TRIBUN_FOLLOWERS_SUCCESS:
      return {
        ...state,
        follow: action.payload.users.length
          ? [...state.follow, ...action.payload.users]
          : [],
        lastPage: action.lastPage,
        isLoading: false,
        isFollowDataFetch: true,
        error: null,
      };
    case GET_TRIBUN_FOLLOWERS_FAILURE:
      return {
        ...state,
        lastPage: action.lastPage,
        isLoading: false,
        isFollowDataFetch: true,
        error: action.payload,
      };
    case GET_TRIBUN_PUSH_FOLLOWING_USERS_REQUEST:
      return {
        ...state,
        isLoading: true,
        isFollowDataFetch: false,
        error: null,
      };
    case GET_TRIBUN_PUSH_FOLLOWING_USERS_SUCCESS:
      return {
        ...state,
        notificationUser: action.payload.users.length
          ? [...state.notificationUser, ...action.payload.users]
          : [],
        lastPage: action.lastPage,
        isLoading: false,
        isFollowDataFetch: true,
        error: null,
      };
    case GET_TRIBUN_PUSH_FOLLOWING_USERS_FAILURE:
      return {
        ...state,
        lastPage: action.lastPage,
        isLoading: false,
        isFollowDataFetch: true,
        error: action.payload,
      };
    case GET_TRIBUN_PUSH_FOLLOWING_USERS_RESET:
      return {
        ...state,
        notificationUser: [],
        isLoading: false,
        isFollowDataFetch: false,
        error: null,
      };
    case GET_TRIBUN_BLOCKED_USERS_REQUEST:
      return {
        ...state,
        isLoading: true,
        isFollowDataFetch: false,
        error: null,
      };
    case GET_TRIBUN_BLOCKED_USERS_SUCCESS:
      return {
        ...state,
        blockUser: action.payload.users.length
          ? [...state.blockUser, ...action.payload.users]
          : [],
        lastPage: action.lastPage,
        isLoading: false,
        isFollowDataFetch: true,
        error: null,
      };
    case GET_TRIBUN_BLOCKED_USERS_RESET:
      return {
        ...state,
        blockUser: [],
        isLoading: false,
        isFollowDataFetch: false,
        error: null,
      };
    case GET_TRIBUN_MUTED_USERS_REQUEST:
      return {
        ...state,
        isLoading: true,
        isFollowDataFetch: false,
        error: null,
      };
    case GET_TRIBUN_MUTED_USERS_SUCCESS:
      return {
        ...state,
        mutedUsers: action.payload.users.length
          ? [...state.mutedUsers, ...action.payload.users]
          : [],
        lastPage: action.lastPage,
        isLoading: false,
        isFollowDataFetch: true,
        error: null,
      };
    case GET_TRIBUN_MUTED_USERS_RESET:
      return {
        ...state,
        mutedUsers: [],
        isLoading: false,
        isFollowDataFetch: false,
        error: null,
      };
    case GET_TRIBUN_MUTED_USERS_FAILURE:
      return {
        ...state,
        mutedUsers: [],
        lastPage: action.lastPage,
        isLoading: false,
        isFollowDataFetch: true,
        error: action.payload,
      };
    case GET_TRIBUN_BLOCKED_USERS_FAILURE:
      return {
        ...state,
        lastPage: action.lastPage,
        isLoading: false,
        isFollowDataFetch: true,
        error: action.payload,
      };

    case FOLLOW_TRIBUN_USER_REQUEST:
      return { ...state, isLoading: true, error: null };

    case FOLLOW_TRIBUN_USER_SUCCESS: {
      if (action.tabType === 'followers' || action.tabType === 'followings') {
        state.follow.map(item => {
          if (action.userId === item.userId) {
            item.following = !item.following;
            item.following ? ++item.stats.followers : --item.stats.followers;
          }
        });
      } else if (action.tabType === 'profile') {
        state.today.map(item => {
          item.user.following = !item.user.following;
          item.user.following
            ? ++item.user.stats.followers
            : --item.user.stats.followers;
        });
        state.past.map(item => {
          item.user.following = !item.user.following;
          item.user.following
            ? ++item.user.stats.followers
            : --item.user.stats.followers;
        });
        state.pinned.map(item => {
          item.user.following = !item.user.following;
          item.user.following
            ? ++item.user.stats.followers
            : --item.user.stats.followers;
        });
      }
      return { ...state, isLoading: false, error: null };
    }

    case FOLLOW_TRIBUN_USER_FAILURE:
      return { ...state, isLoading: false, error: action.payload };

    case SHOW_OR_HIDE_CHECKBOX_TRIBUN_COUPONS_REQUEST:
      return { ...state, isLoading: true, error: null };
    case SHOW_OR_HIDE_CHECKBOX_TRIBUN_COUPONS_SUCCESS:
      return {
        ...state,
        profile: {
          ...state.profile,
          showHiddenCoupons: action.payload,
        },
        isLoading: false,
        error: null,
      };
    case SHOW_OR_HIDE_CHECKBOX_TRIBUN_COUPONS_FAILURE:
      return { ...state, isLoading: false, error: action.payload };

    case SHOW_OR_HIDE_COUOPON_REQUEST:
      return { ...state, isLoading: true, error: null };

    case SHOW_OR_HIDE_COUOPON_SUCCESS: {
      let newState = { ...state };

      if (action.tabType === 'profile') {
        newState = {
          ...state,
          past: state.past.map(feed => {
            if (feed.feedId === action.feedId) {
              feed.hidden = !feed.hidden;
              return feed;
            } else {
              return feed;
            }
          }),
          pinned: state.pinned.map(feed => {
            if (feed.feedId === action.feedId) {
              feed.hidden = !feed.hidden;
              return feed;
            } else {
              return feed;
            }
          }),
          today: state.today.map(feed => {
            if (feed.feedId === action.feedId) {
              feed.hidden = !feed.hidden;

              return feed;
            } else {
              return feed;
            }
          }),
        };
      } else {
        return {
          ...state,
          data: action.payload,
          isLoading: false,
          error: null,
        };
      }

      return newState;
    }

    case SHOW_OR_HIDE_COUOPON_FAILURE:
      return { ...state, isLoading: false, error: action.payload };

    case SEND_COMMENT_REQUEST:
      return { ...state, isLoading: true, error: null };

    case SEND_COMMENT_SUCCESS: {
      let newState = { ...state };

      if (action.tabType === 'profile') {
        newState = {
          ...state,
          past: state.past.map(feed => {
            if (feed.feedId === action.feedId) {
              feed.comments += 1;
              return feed;
            } else {
              return feed;
            }
          }),
          pinned: state.pinned.map(feed => {
            if (feed.feedId === action.feedId) {
              feed.comments += 1;
              return feed;
            } else {
              return feed;
            }
          }),
          today: state.today.map(feed => {
            if (feed.feedId === action.feedId) {
              feed.comments += 1;
              return feed;
            } else {
              return feed;
            }
          }),
        };
      } else {
        return {
          ...state,
          data: action.payload,
          isLoading: false,
          error: null,
        };
      }

      return newState;
    }

    case DELETE_COMMENT_FAILURE:
      return { ...state, isLoading: false, error: action.payload };

    case DELETE_COMMENT_REQUEST:
      return { ...state, isLoading: true, error: null };

    case DELETE_COMMENT_SUCCESS: {
      let newState = { ...state };

      if (action.tabType === 'profile') {
        newState = {
          ...state,
          past: state.past.map(feed => {
            if (feed.feedId === action.feedId) {
              feed.comments -= 1;
              return feed;
            } else {
              return feed;
            }
          }),
          pinned: state.pinned.map(feed => {
            if (feed.feedId === action.feedId) {
              feed.comments -= 1;
              return feed;
            } else {
              return feed;
            }
          }),
          today: state.today.map(feed => {
            if (feed.feedId === action.feedId) {
              feed.comments -= 1;
              return feed;
            } else {
              return feed;
            }
          }),
        };
      } else {
        return {
          ...state,
          data: action.payload,
          isLoading: false,
          error: null,
        };
      }

      return newState;
    }

    case SEND_COMMENT_FAILURE:
      return { ...state, isLoading: false, error: action.payload };

    case COMMENT_FORBID_ALLOW_REQUEST:
      return { ...state, isLoading: true, error: null };

    case COMMENT_FORBID_ALLOW_SUCCESS: {
      let newState = { ...state };

      if (action.tabType === 'profile') {
        newState = {
          ...state,
          past: state.past.map(feed => {
            if (feed.feedId === action.feedId) {
              feed.commentForbidden = !feed.commentForbidden;
              return feed;
            } else {
              return feed;
            }
          }),
          pinned: state.pinned.map(feed => {
            if (feed.feedId === action.feedId) {
              feed.commentForbidden = !feed.commentForbidden;
              return feed;
            } else {
              return feed;
            }
          }),
          today: state.today.map(feed => {
            if (feed.feedId === action.feedId) {
              feed.commentForbidden = !feed.commentForbidden;
              return feed;
            } else {
              return feed;
            }
          }),
        };
      } else {
        return {
          ...state,
          data: action.payload,
          isLoading: false,
          error: null,
        };
      }

      return newState;
    }

    case COMMENT_FORBID_ALLOW_FAILURE:
      return { ...state, isLoading: false, error: action.payload };

    case SET_PIN_FEED_REQUEST:
      return { ...state, isLoading: true, error: null };
    case SET_PIN_FEED_SUCCESS: {
      return { ...state, isLoading: false, error: null };
    }
    case SET_PIN_FEED_FAILURE:
      return { ...state, isLoading: false, error: action.payload };

    case REMOVE_PIN_FEED_REQUEST:
      return { ...state, isLoading: true, error: null };
    case REMOVE_PIN_FEED_SUCCESS: {
      return { ...state, isLoading: false, error: null };
    }
    case REMOVE_PIN_FEED_FAILURE:
      return { ...state, isLoading: false, error: action.payload };
    case GET_PINNED_FEED_REQUEST:
      return { ...state, isLoading: true, error: null };
    case GET_PINNED_FEED_SUCCESS: {
      let newState = { ...state };
      if (action.payload && action.payload.length) {
        newState = {
          ...state,
          pinned: action.payload.map(feed => {
            feed.pinned = true;
            return feed;
          }),
          isLoading: false,
        };
        return newState;
      } else {
        newState = {
          ...state,
          pinned: [],
          isLoading: false,
        };
        return newState;
      }
    }
    case GET_PINNED_FEED_FAILURE:
      return { ...state, isLoading: false, error: action.payload };

    case UPDATE_TRIBUN_COUPON_NAME_REQUEST:
      return { ...state, isLoading: true, error: null };
    case UPDATE_TRIBUN_COUPON_NAME_SUCCESS: {
      let newState = { ...state };

      newState = {
        ...state,
        past: state.past.map(feed => {
          if (feed.feedId === action.feedId) {
            feed.description = action.description;
            return feed;
          } else {
            return feed;
          }
        }),
        pinned: state.pinned.map(feed => {
          if (feed.feedId === action.feedId) {
            feed.description = action.description;
            return feed;
          } else {
            return feed;
          }
        }),
        today: state.today.map(feed => {
          if (feed.feedId === action.feedId) {
            feed.description = action.description;
            return feed;
          } else {
            return feed;
          }
        }),
      };

      return newState;
    }
    case UPDATE_TRIBUN_COUPON_NAME_FAILURE:
      return { ...state, isLoading: false, error: action.payload };

    case DELETE_TRIBUN_COUPON_NAME_REQUEST:
      return { ...state, isLoading: true, error: null };

    case DELETE_TRIBUN_COUPON_NAME_SUCCESS: {
      let newState = { ...state };

      newState = {
        ...state,
        past: state.past.map(feed => {
          if (feed.feedId === action.feedId) {
            feed.description = null;
            return feed;
          } else {
            return feed;
          }
        }),
        pinned: state.pinned.map(feed => {
          if (feed.feedId === action.feedId) {
            feed.description = null;
            return feed;
          } else {
            return feed;
          }
        }),
        today: state.today.map(feed => {
          if (feed.feedId === action.feedId) {
            feed.description = null;
            return feed;
          } else {
            return feed;
          }
        }),
      };

      return newState;
    }
    case DELETE_TRIBUN_COUPON_NAME_FAILURE:
      return { ...state, isLoading: false, error: action.payload };
    default:
      return state;
  }
};